/* eslint-disable no-console */
/* eslint-disable max-len */
import { GNB_BASE_URL, LOAD_BASE_URL, ENV_TYPE } from '../../config';
import {
  // eslint-disable-next-line max-len
  getPeriod, serverDate, uuid,
} from '../utils/common';

const tag = {};
const opt = {};
opt.gnbOpen = false;
tag.wrapper = document.querySelector('#wrapper');
tag.target = document.querySelector('header');

function disableScrolling() {
  document.body.style.overflow = 'hidden';
  document.body.style.height = '100%';
}

function enableScrolling() {
  document.body.style.overflow = 'inherit';
  document.body.style.height = 'inherit';
}

const full = getPeriod('full', 'early');
const ten = getPeriod('ten', 'early');
// 멤버십 10km, 풀코스 기간에 해당되지만, uuid가 없는 경우
const isMembershipProd = (serverDate() >= full.open && serverDate() <= full.close) && (serverDate() >= ten.open && serverDate() <= ten.close) && !uuid;

function gnbDrop() {
  if (opt.gnbOpen) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < tag.dropdownBtn.length; i++) {
      tag.dropdownBtn[i].addEventListener('click', (e) => {
        if (!e.currentTarget.classList.contains('ac')) {
          if (e.currentTarget.parentNode.parentNode.classList.contains('drop')) {
            e.currentTarget.parentNode.parentNode.classList.remove('drop');
          } else {
            // eslint-disable-next-line no-plusplus
            for (let j = 0; j < tag.dropdownBtn.length; j++) {
              tag.dropdownBtn[j].parentNode.parentNode.classList.remove('drop');
            }
            e.currentTarget.parentNode.parentNode.classList.add('drop');
            console.log(e);
          }
          e.preventDefault();
        }
      });
    }
  }
}

tag.gnb = document.querySelector('.ch_gnb');
tag.gnb.innerHTML += `
<div class="inner">
      <h1 class="logo">
        <div class="logo1"><a href="${GNB_BASE_URL}/index.html?v3"><img class="logo_white" src="https://image.chosun.com/chuncheonmarathon/2026/logo-white.png" alt="chuncheon marathon"><img class="logo_black" src="https://image.chosun.com/chuncheonmarathon/2026/logo-black.png" alt="chuncheon marathon"></a></div>
        <div class="logo2"><a href="${GNB_BASE_URL}/index.html?v3"><img class="logo_white" src="https://image.chosun.com/chuncheonmarathon/2023/main/gnb_logo2.png" alt="chuncheon marathon"><img class="logo_black" src="https://image.chosun.com/chuncheonmarathon/2023/main/gnb_logo2_black.png" alt="chuncheon marathon"></a></div>
      </h1>
      <div class="cate">
        <div class="depth1">
          <span><a href="${GNB_BASE_URL}/rally/info.html">대회안내</a></span>
          <ul class="depth2">
            <li><a href="${GNB_BASE_URL}/rally/info.html">대회요강</a></li>
            <li><a href="${GNB_BASE_URL}/rally/notes.html">대회유의사항</a></li>
            <li><a href="${GNB_BASE_URL}/rally/logo.html">춘천마라톤 CI</a></li>
          </ul>
        </div>
        <div class="depth1">
          <span><a href="${GNB_BASE_URL}/apply/part-application.html">참가신청</a></span>
          <ul class="depth2">
            <li><a href="${GNB_BASE_URL}/apply/part-application.html">일반 신청</a></li>
            <!-- <li><a href="${
  // eslint-disable-next-line no-nested-ternary
  isMembershipProd
    ? (ENV_TYPE === 'prod'
      ? 'https://www.chosun.com/early/chuncheonmarathon/'
      : 'https://sandbox.chosun.com/test/chuncheonmarathon/')
    : `${GNB_BASE_URL}/apply/part-agree-early.html`
}">얼리버드 신청</a></li> -->
            <!-- <li><a href="${GNB_BASE_URL}/add/part-full.html?raceType=hof">명예의전당 헌액 예정자 신청</a></li> -->
            <!-- <li><a href="${GNB_BASE_URL}/add/part-full.html?raceType=subhof">풀코스 5-8회 완주자 신청</a></li> -->
            <li><a href="${GNB_BASE_URL}/apply/part-confirm.html">신청확인 / 결제</a></li>
            <li><a href="${GNB_BASE_URL}/apply/part-agreement.html">참가자 동의사항</a></li>
            <li><a href="${GNB_BASE_URL}/apply/bus.html">마라톤 버스 예약</a></li>
          </ul>
        </div>
        <div class="depth1">
          <span><a href="${GNB_BASE_URL}/course/video.html">대회코스</a></span>
          <ul class="depth2">
            <li><a href="${GNB_BASE_URL}/course/video.html">코스영상</a></li>
            <li><a href="${GNB_BASE_URL}/course/info.html">코스도/고저도</a></li>
            <li><a href="${GNB_BASE_URL}/course/exploration.html">코스답사/전략</a></li>
            <li><a href="${GNB_BASE_URL}/course/point.html">집결/출발</a></li>
            <li><a href="${GNB_BASE_URL}/course/sitemap.html">대회장 안내</a></li>
            <li><a href="${GNB_BASE_URL}/course/trafic.html">교통통제 시간표</a></li>
          </ul>
        </div>
        <div class="depth1">
          <span><a class="ac" href="${GNB_BASE_URL}/gift/info.html">기념품</a></span>
          <ul class="depth2">
          <li><a href="${GNB_BASE_URL}/gift/info.html">기념품</a></li>
        </ul>
        </div>
        <div class="depth1">
          <span><a href="${GNB_BASE_URL}/record/tournament.html">대회기록</a></span>
          <ul class="depth2">
            <li><a href="${GNB_BASE_URL}/record/tournament.html">대회 기록</a></li>
            <li><a href="${GNB_BASE_URL}/record/all-time.html">역대 기록</a></li>
          </ul>
        </div>
        <div class="depth1">
        <span><a class="ac" href="${GNB_BASE_URL}/honor/honor-record.html">명예의 전당</a></span>
          <ul class="depth2">
            <li><a href="${GNB_BASE_URL}/honor/honor-record.html">명예의 전당</a></li>
          </ul>
        </div>
        <div class="depth1">
          <span><a href="https://board.chosun.com//nbrd/bbs/list.html?b_bbs_id=10005&branch=&pn=1">커뮤니티</a></span>
          <ul class="depth2">
            <li><a href="https://board.chosun.com//nbrd/bbs/list.html?b_bbs_id=10005&branch=&pn=1">공지사항</a></li>
            <li><a href="${GNB_BASE_URL}/community/faq.html">FAQ</a></li>
          </ul>
        </div>
      </div>
      <div class="close_btn"><img src="https://image.chosun.com/chuncheonmarathon/2023/main/close.png" alt="close" /></div>
      <div class="gnb_menu_btn"><button><img class="btn_white" src="https://image.chosun.com/chuncheonmarathon/2023/main/menu_btn.png" alt="category button"><img class="btn_black" src="https://image.chosun.com/chuncheonmarathon/2023/main/menu_btn_black.png" alt="category button"></button></div>
    </div>
`;
tag.gnbOpenBtn = document.querySelector('.gnb_menu_btn');
tag.gnbCloseBtn = document.querySelector('.close_btn');
tag.dropdownBtn = document.querySelectorAll('.depth1>span>a');
tag.topNotice = document.querySelector('.top_notice a');
tag.alertCate = document.querySelectorAll('.alert_cate');
tag.gnbOpenBtn.addEventListener('click', (e) => {
  tag.gnb.classList.add('on');
  opt.gnbOpen = true;
  disableScrolling();
  gnbDrop();
  e.preventDefault();
});

tag.gnbCloseBtn.addEventListener('click', (e) => {
  tag.gnb.classList.remove('on');
  opt.gnbOpen = false;
  enableScrolling();
  e.preventDefault();
});

const stickyMenu = () => {
  const offsetY = window.scrollY;
  const stickyPos = tag.gnb.offsetHeight;
  if (offsetY >= stickyPos) {
    tag.gnb.classList.add('sticky');
  } else {
    tag.gnb.classList.remove('sticky');
  }
};

export const getListData = async () => {
  try {
    const response = await fetch(`${LOAD_BASE_URL}/json/chuncheon-board.json`);
    const data = await response.json();
    tag.topNotice.href = `https://board.chosun.com/${data.data[0].link}`;
    tag.topNotice.innerHTML = data.data[0].title;
  } catch (e) {
    console.log(e);
    document.querySelector('.top_notice').style.display = 'none';
    tag.gnb.classList.add('board_none');
  }
};

export const mainFn = () => {
  const listRenderTarget = document.querySelector('#notice ul');

  const getBoardData = async () => {
    try {
      const response = await fetch(`${LOAD_BASE_URL}/json/chuncheon-board.json`);
      const data = await response.json();
      // eslint-disable-next-line no-use-before-define
      renderList(data);
    } catch (e) {
      console.log(e);
    }
  };

  const renderList = (res) => {
    res.data.forEach((item, i) => {
      if (i < 5) {
        listRenderTarget.innerHTML += `
          <li>
            <a href="https://board.chosun.com/${item.link}" target="_blank">
              <span class="icon">${item.category}</span>
              <span class="tt">${item.title}</span>
            </a>
            <span class="date">${item.regdate.split(' ')[0]}</span>
          </li>
        `;
      }
    });
  };

  return {
    listHandler: () => {
      if (listRenderTarget) {
        getBoardData();
      }
    },
  };
};

document.addEventListener('scroll', stickyMenu);
